export const throttle = (
  fn: (...args) => void,
  delay: number,
): ((...args) => void) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
};
